import { catchError, throwError } from 'rxjs';

import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { EsnToastService } from './toast.service';

/**
 * Pulls the BFF's error message out of a failed HTTP response.
 */
export function esnHttpErrorMessage(err: HttpErrorResponse): string {
  // NestJS error body: { statusCode, message, error }. `message` is a string,
  // or — for validation errors — an array of strings.
  const body = err.error as { message?: string | string[] } | string | null;
  const raw = typeof body === 'string' ? body : body?.message;
  if (Array.isArray(raw)) return raw.join('; ');
  if (typeof raw === 'string' && raw.trim().length > 0) return raw;
  return err.status > 0 ? `Request failed (${err.status} ${err.statusText})` : 'Could not reach the server.';
}

/**
 * Tells the user when an API call failed: shows the BFF's message as a danger toast, then
 * rethrows so callers can still react. 401 is skipped — the auth flow handles re-login.
 */
export const esnHttpErrorToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(EsnToastService);
  return next(req).pipe(catchError((err: unknown) => {
    if (err instanceof HttpErrorResponse && err.status !== 401) toast.error(esnHttpErrorMessage(err));
    return throwError(() => err);
  }));
};
